import React from "react";
import TenantDetails from "./views/TenantDetails";
import { TenantDetailsContextProvider } from "./TenantDetailsView";

const TenantDetailsPage = () => {
  return (
    <TenantDetailsContextProvider>
      <TenantDetails />
    </TenantDetailsContextProvider>
  );
};

export default TenantDetailsPage;
